import { render, staticRenderFns } from "./projectLabelCostStat.vue?vue&type=template&id=3fc28e44&scoped=true&"
import script from "./projectLabelCostStat.vue?vue&type=script&lang=js&"
export * from "./projectLabelCostStat.vue?vue&type=script&lang=js&"
import style0 from "./projectLabelCostStat.vue?vue&type=style&index=0&id=3fc28e44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc28e44",
  null
  
)

component.options.__file = "projectLabelCostStat.vue"
export default component.exports